import { gql } from '@apollo/client';
import { OrderState, UpdateOrderAction } from '../useUpdateOrder';
import { ORDER_SUMMARY_FRAGMENT, OrderSummary } from '../useOrderSummary';
import { ORDER_ITEM_FRAGMENT, OrderItem } from '../useOrder';

export type UpdateOrderRewardsUseMutation = {
  updateOrderSiteCreditOrRewardsUse: {
    __typename: 'UpdateOrderSiteCreditOrRewardsUsePayload';
    data: OrderSummary[];
    included: OrderItem[];
  };
};

export type UpdateOrderRewardsUseMutationVariables = {
  orderId: string;
  input: {
    data: {
      action_type: UpdateOrderAction.UpdatePayment;
      attributes: {
        country_code: string;
        use_mo_rewards: boolean;
        use_site_credit: boolean;
        order_state: OrderState.PayRemainingBalance;
        selected_item_ids: number[];
      };
      id: string;
      type: 'order_summary';
    };
  };
};

export const UPDATE_ORDER_REWARDS_USE_MUTATION = gql`
  mutation UpdateOrderRewardsUseMutation($orderId: String!, $input: Input!) {
    updateOrderSiteCreditOrRewardsUse(orderId: $orderId, input: $input)
      @rest(
        type: "UpdateOrderSiteCreditOrRewardsUsePayload"
        endpoint: "cart"
        path: "/v3.5/order_summary/{args.orderId}"
        method: "PATCH"
      ) {
      data @type(name: "RestOrderSummary") {
        ...OrderSummaryFragment
      }
      included @type(name: "RestOrderItem") {
        ...OrderItemFragment
      }
    }
  }
  ${ORDER_SUMMARY_FRAGMENT}
  ${ORDER_ITEM_FRAGMENT}
`;
